/**
 * QuickView Helper Functions
 * Contains utility functions for FastSimon QuickView generation
 */

import { formatMoney } from '../../utils/currency';

let theme = window.theme || {};
let Shopify = window.Shopify || {};

/**
 * Set and push monetate data
 * @param {*} variant - variant object
 * @param {*} product_json - product object
 */
export const pushMonetateData = (variant, product_json) => {
  const quickviewElement = document.getElementById('Quickview');
  const quickviewElement2 = document.getElementById('QuickView');

  const cartRows = [];
  if (window.cart && window.cart.items && window.cart.items.length > 0) {
    // window.cart.items.forEach((cartItem, index) => {
    window.cart.items.forEach((cartItem) => {
      var price = formatMoney(cartItem.price, theme.moneyFormat);
      price = price.replace(/[$A-Za-z,\s]+/g, '');
      if (!/^\d/.test(price)) {
        price = price.slice(1);
      }
      const cartRow = {
        productId: cartItem.product_id.toString(),
        quantity: cartItem.quantity.toString(),
        unitPrice: price,
        currency: Shopify.currency.active.toString(),
        sku: cartItem.variant_id.toString(),
      };

      cartRows.push(cartRow);
    });
  }

  let monetateQPushTimeout = 0;

  if (
    (quickviewElement && quickviewElement.classList.contains('Modal--open')) ||
    (quickviewElement2 && quickviewElement2.classList.contains('Modal--open'))
  ) {
    window.monetateQ = window.monetateQ || [];

    clearTimeout(monetateQPushTimeout);
    // Defer monetateQ push
    monetateQPushTimeout = setTimeout(() => {
      window.monetateQ.push([
        'addProductDetails',
        [
          {
            productId: product_json.id.toString(),
            sku: variant.id.toString(),
          },
        ],
      ]);
      window.monetateQ.push(['addCartRows', cartRows]);
      window.monetateQ.push(['setPageType', 'quickview']);
      window.monetateQ.push(['trackData']);
    }, 500);
  } else {
    window.monetateQ = window.monetateQ || [];

    clearTimeout(monetateQPushTimeout);
    // Defer monetateQ push
    monetateQPushTimeout = setTimeout(() => {
      window.monetateQ.push([
        'addProductDetails',
        [
          {
            productId: product_json.id.toString(),
            sku: variant.id.toString(),
          },
        ],
      ]);
      window.monetateQ.push(['addCartRows', cartRows]);
      window.monetateQ.push(['setPageType', 'product']);
      window.monetateQ.push(['trackData']);
    }, 500);
  }
};

/**
 * Generate breadcrumbs based on variant barcode
 * Based on ProductBreadcrumbs.liquid logic
 * @param {string} barcode - The variant barcode
 * @returns {string} HTML string for breadcrumbs
 */
export const generateBreadcrumbs = (barcode) => {
  if (!barcode) return '';

  let breadcrumbHTML = '';

  if (barcode.includes('05001')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-short-mini">Mini Dresses</a>`;
  } else if (barcode.includes('05002')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-long">Long Dresses</a>`;
  } else if (barcode.includes('05003') || barcode.includes('05005')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-formal">Formal Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-specialty-gowns">Specialty Gowns</a>`;
  } else if (barcode.includes('05004')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-formal">Formal Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-ball-gowns">Ball Gowns</a>`;
  } else if (barcode.includes('05006') || barcode.includes('05007')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-two-piece">Two-Piece Dresses</a>`;
  } else if (barcode.includes('05008') || barcode.includes('06202') || barcode.includes('06204')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/jackets">Jackets</a>`;
  } else if (barcode.includes('05101')) {
    breadcrumbHTML = `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>`;
  } else if (barcode.includes('05102')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-casual">Casual Dresses</a>`;
  } else if (barcode.includes('05103')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-club-bodycon">Club & Bodycon Dresses</a>`;
  } else if (barcode.includes('05104')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections/dresses-skater">Skater Dresses</a>`;
  } else if (barcode.includes('06001') || barcode.includes('06003')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/tops">Tops</a>`;
  } else if (barcode.includes('06002')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/tops">Tops</a>` +
      `<a href="https://www.windsorstore.com/collections/tops-tanks-tees">Tanks & Tees</a>`;
  } else if (barcode.includes('06005')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/tops">Tops</a>` +
      `<a href="https://www.windsorstore.com/collections/tops-sweaters-cardigans">Sweaters & Cardigans</a>`;
  } else if (barcode.includes('06201')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/jackets">Jackets</a>` +
      `<a href="https://www.windsorstore.com/collections/jackets-trench-coats">Coats</a>`;
  } else if (barcode.includes('06203')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/jackets">Jackets</a>` +
      `<a href="https://www.windsorstore.com/collections/trends-denim-outfits">Denim Outfits</a>` +
      `<a href="https://www.windsorstore.com/collections/jackets-denim">Denim Jackets</a>`;
  } else if (barcode.includes('06301') || barcode.includes('06401') || barcode.includes('06501')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-skirts">Skirts</a>`;
  } else if (barcode.includes('06302') || barcode.includes('06402') || barcode.includes('06502')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-pants">Pants</a>`;
  } else if (barcode.includes('06303') || barcode.includes('06403') || barcode.includes('06503')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-shorts">Shorts</a>`;
  } else if (barcode.includes('06601')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/trends-denim-outfits">Denim Outfits</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-denim">Denim Skirts</a>`;
  } else if (barcode.includes('06602')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/trends-denim-outfits">Denim Outfits</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-denim">Jeans & Denim Bottoms</a>`;
  } else if (barcode.includes('06603')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms">Bottoms</a>` +
      `<a href="https://www.windsorstore.com/collections/trends-denim-outfits">Denim Outfits</a>` +
      `<a href="https://www.windsorstore.com/collections/bottoms-denim-shorts">Denim Shorts</a>`;
  } else if (barcode.includes('07001')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry">Jewelry</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry-earrings">Earrings</a>`;
  } else if (barcode.includes('07002')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry">Jewelry</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry-necklaces-chokers">Necklaces & Chokers</a>`;
  } else if (barcode.includes('07003')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry">Jewelry</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry-bracelets">Bracelets</a>`;
  } else if (barcode.includes('07004')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry">Jewelry</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry-rings">Rings</a>`;
  } else if (barcode.includes('07005') || barcode.includes('07007')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-jewelry">Jewelry</a>`;
  } else if (barcode.includes('07006')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-hair">Hair Accessories</a>`;
  } else if (barcode.includes('07008')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-sunglasses">Sunglasses</a>`;
  } else if (barcode.includes('07101')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear">Intimates & Sleepwear</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear-lingerie-accessories">Lingerie Accessories</a>`;
  } else if (barcode.includes('07102') || barcode.includes('17102')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear">Intimates & Sleepwear</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear-shapewear">Shapewear</a>`;
  } else if (
    barcode.includes('07103') ||
    barcode.includes('07106') ||
    barcode.includes('17103') ||
    barcode.includes('17106')
  ) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear">Intimates & Sleepwear</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear-pajamas">Sleepwear</a>`;
  } else if (barcode.includes('07104') || barcode.includes('17104')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits">Swimsuits</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits-bikinis">Bikinis</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits-bikinis-tops">Bikini Tops</a>`;
  } else if (barcode.includes('07105') || barcode.includes('17105')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits">Swimsuits</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits-bikinis">Bikinis</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits-bikinis-bottoms">Bikini Bottoms</a>`;
  } else if (
    barcode.includes('07107') ||
    barcode.includes('07108') ||
    barcode.includes('17101') ||
    barcode.includes('17107')
  ) {
    // Note: 07101 had a more specific mapping earlier (Lingerie Accessories) and will have matched already.
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear">Intimates & Sleepwear</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear-bras-bralettes-lingerie">Bras, Bralettes, & Lingerie</a>`;
  } else if (barcode.includes('07109')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits">Swimsuits</a>` +
      `<a href="https://www.windsorstore.com/collections/swimsuits-one-pieces">One Piece Swimsuits</a>`;
  } else if (barcode.includes('07201') || barcode.includes('07203') || barcode.includes('07204')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-purses-bags">Bags & Purses</a>`;
  } else if (barcode.includes('07202') || barcode.includes('07307')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-beauty">Beauty</a>`;
  } else if (barcode.includes('07301')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-belts">Belts</a>`;
  } else if (barcode.includes('07302')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-hats">Hats</a>`;
  } else if (barcode.includes('07304') || barcode.includes('07309') || barcode.includes('07310')) {
    breadcrumbHTML = `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>`;
  } else if (barcode.includes('07305')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/clothing">Clothing</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-scarves-wraps">Scarves & Wraps</a>`;
  } else if (barcode.includes('07306')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/intimates-sleepwear-hosiery-socks">Hosiery & Socks</a>`;
  } else if (barcode.includes('07308')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/accessories">Accessories</a>` +
      `<a href="https://www.windsorstore.com/collections/accessories-gifts-novelty">Gifts & Novelty</a>`;
  } else if (barcode.includes('07401')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-heels">Heels</a>`;
  } else if (barcode.includes('07402')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-boots-booties">Boots & Booties</a>`;
  } else if (barcode.includes('07403')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-boots-booties">Boots & Booties</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-ankle-boots">Ankle Boots</a>`;
  } else if (barcode.includes('07404')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-sandals">Sandals</a>`;
  } else if (barcode.includes('07405') || barcode.includes('07407') || barcode.includes('07408')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-flats-sneakers/">Flats & Sneakers</a>`;
  } else if (barcode.includes('07406')) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/shoes">Shoes</a>` +
      `<a href="https://www.windsorstore.com/collections/shoes-wedges">Wedges</a>`;
  } else if (
    barcode.includes('15001') ||
    barcode.includes('15002') ||
    barcode.includes('15004') ||
    barcode.includes('15005') ||
    barcode.includes('15006') ||
    barcode.includes('15008') ||
    barcode.includes('15101') ||
    barcode.includes('15102') ||
    barcode.includes('15103')
  ) {
    breadcrumbHTML =
      `<a href="https://www.windsorstore.com/collections/dresses">Dresses</a>` +
      `<a href="https://www.windsorstore.com/collections//plus-size-clothing">Plus Size Dresses</a>`;
  } else {
    breadcrumbHTML = `<a href="https://www.windsorstore.com/collections/all">All Products</a>`;
  }

  // Return as a single line: remove newlines, collapse excess spaces, and strip gaps between tags
  return `<div class="Breadcrumb"><div class="BreadcrumbOtherPage"><span class="Breadcrumb__link">${breadcrumbHTML}</span></div></div>`;
};
/**
 * Format color name for CSS class
 * Removes numbers and special characters, converts to lowercase with underscores
 * @param {string} color - The color name
 * @returns {string} Formatted color class name
 */
export const formatColorClass = (color) => {
  return color
    .replace(/[0-9]/g, '') // Remove numbers like in Liquid filter
    .toLowerCase()
    .replace(/[^a-z\s]/g, '') // Remove special characters
    .trim()
    .replace(/\s+/g, '_'); // Replace spaces with underscores
};

/**
 * Create Shopify-compatible product object
 * @param {Object} productData - FastSimon product data
 * @param {Array} variants - Processed variants array
 * @param {Array} allProductImages - All product images
 * @param {Array} variantImages - Current variant images
 * @param {string} productId - Product ID
 * @param {string} title - Product title
 * @param {string} productUrl - Product URL
 * @param {Array} colors - Available colors
 * @param {Array} sizes - Available sizes
 * @param {Object} selectedVariant - Currently selected variant
 * @returns {Object} Shopify-compatible product object
 */
export const createShopifyCompatibleProduct = (
  productData,
  variants,
  allProductImages,
  variantImages,
  productId,
  title,
  productUrl,
  colors,
  sizes,
  selectedVariant,
) => {
  return {
    id: productId,
    title: title,
    handle: productUrl.split('/products/')[1]?.split('?')[0] || 'unknown',
    vendor: 'Windsor',
    type: 'Dress',
    url: productUrl,
    // Convert our FastSimon variants to Shopify variant format
    variants: variants.map((variant, index) => ({
      id: variant.variant_id,
      title: `${variant.Color} / ${variant.Size}`,
      option1: variant.Color,
      option2: variant.Size,
      option3: null,
      sku: variant['Product-sku'] || variant.Barcode,
      requires_shipping: true,
      taxable: true,
      featured_image: variant.image_url
        ? {
            id: `${variant.variant_id}-image`,
            product_id: productId,
            position: index + 1,
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString(),
            alt: title,
            width: 633,
            height: 715,
            src: variant.image_url,
            variant_ids: [variant.variant_id],
          }
        : null,
      available: variant.Sellable === true,
      name: `${title} - ${variant.Color} / ${variant.Size}`,
      public_title: `${variant.Color} / ${variant.Size}`,
      options: [variant.Color, variant.Size],
      price: variant.price || 0,
      weight: 0,
      compare_at_price: variant.compare_at_price || null,
      inventory_management: 'shopify',
      barcode: variant.Barcode,
      featured_media: variant.image_url
        ? {
            alt: title,
            id: `${variant.variant_id}-media`,
            position: index + 1,
            preview_image: {
              aspect_ratio: 0.885,
              height: 715,
              width: 633,
              src: variant.image_url,
            },
          }
        : null,
    })),
    options: [
      {
        id: 'option1',
        name: 'Color',
        position: 1,
        values: colors,
      },
      {
        id: 'option2',
        name: 'Size',
        position: 2,
        values: sizes,
      },
    ],
    images: variantImages.map((img, index) => ({
      id: `image-${index}`,
      product_id: productId,
      position: index + 1,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      alt: title,
      width: 633,
      height: 715,
      src: img,
      variant_ids: variants.filter((v) => v.image_url === img).map((v) => v.variant_id),
    })),
    featured_image: variantImages[0] || null,
    // Keep original FastSimon data for reference
    _fastsimon_data: {
      original: productData,
      processed_variants: variants,
      selected_variant: selectedVariant,
      all_images: allProductImages,
      current_variant_images: variantImages,
    },
  };
};

/**
 * Build Yotpo review HTML based on ProductHeading.liquid structure
 * @param {string} productId - The product ID
 * @param {string} title - The product title
 * @param {string} productUrl - The product URL
 * @param {string} imageUrl - The product image URL
 * @param {number} reviewCount - The number of reviews (optional)
 * @returns {string} HTML string for Yotpo reviews
 */
export const buildReviewsHTML = (productId, title, productUrl, imageUrl, reviewCount = 0) => {
  // Get Yotpo app key based on environment (matching ProductHeading.liquid logic)
  const yotpoKey = window.location.hostname.includes('windsor-dev') ? 'your-dev-key' : 'your-prod-key';
  const shopDomain = window.location.hostname.replace('www.', '');
  const currentUrl = window.location.origin + productUrl;
  const description = title; // Use title as description fallback

  // Hide reviews if there are 0 reviews
  const displayStyle = reviewCount === 0 ? 'display: none;' : '';

  return `
    <div class="yotpo bottomLine"
      data-pdp-yotpo
      role="navigation"
      data-quickview-reviews="true"
      data-reviews-click-url="${productUrl}"
      aria-label="Product Reviews Trigger"
      data-appkey="${yotpoKey}"
      data-domain="${shopDomain}"
      data-product-id="${productId}"
      data-product-models="${productId}"
      data-name="${title}"
      data-url="${currentUrl}"
      data-image-url="${imageUrl}"
      data-description="${description}"
      data-bread-crumbs=""
      style="${displayStyle}">
    </div>
  `;
};

/**
 * Build price HTML with sale detection and proper formatting
 * @param {Object} variant - The selected variant object
 * @returns {string} HTML string for price display
 */
export const buildPriceHTML = (variant) => {
  const price = variant?.price / 100 || 0;
  const comparePrice = variant?.compare_at_price / 100 || 0;
  const isOnSale = comparePrice > 0 && comparePrice > price;
  const discountPercent = isOnSale ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
  const priceAriaLabel = isOnSale
    ? `Price: $${price.toFixed(2)} , Original price: $${comparePrice.toFixed(2)}, ${discountPercent}% Off`
    : `Price: $${price.toFixed(2)}`;

  return `
    <div class="ProductHeading__price" tabindex="0" aria-label="${priceAriaLabel}" data-price-wrapper="">
      <span data-product-price="" class="price${isOnSale ? ' sale' : ''}">
        <span role="text">$${price.toFixed(2)}</span>      
      </span>
      ${
        isOnSale
          ? `
        <span class="visually-hidden" data-compare-text="">Regular price</span>
        <span class="ProductHeading__compare-at price" aria-label="Original price" data-compare-price=""><span>$${comparePrice.toFixed(
          2,
        )}</span></span>
        <span class="ProductHeading__discount-wrapper" aria-label="Discount" data-discount-percent=""><span class="ProductHeading__discount">${discountPercent}% Off</span></span>
      `
          : ''
      }
    </div>
  `;
};

// Switch clearance badge based on variant price comparison
export const switchClearanceBadge = (variant) => {
  const badgeClearance = document.querySelector('.ProductBadge--red');
  if (badgeClearance) {
    if (variant.price >= variant.compare_at_price) {
      badgeClearance.style.display = 'none';
    } else {
      badgeClearance.style.display = 'block';
    }
  }
};
